/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-closing-bracket-location */

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default function DivImage({
    role = 'img',
    src,
    className,
    altText = '',
    style,
    ...rest
}) {
    const styleObject = {
        ...style,
    };

    if (src) {
        styleObject.backgroundImage = `url(${src})`;
    }

    return (
        <div
            data-component="FauxImage"
            className={cx('sarsa-faux-image', className)}
            role={role}
            aria-label={role === 'img' ? altText : null}
            style={styleObject}
            {...rest}
        />
    );
}

DivImage.propTypes = {
    src: PropTypes.string,
    altText: PropTypes.string,
    aspectRatio: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    role: PropTypes.string,
};
